import React, {ChangeEvent, useEffect, useRef, useState} from 'react'
import SearchIcon from "./searchIcon.svg";
import ClearIcon from "./clear.svg";

import "./Search.scss"
import InputBase from '@material-ui/core/InputBase';
import {IconButton} from '@material-ui/core'
import {InputBaseProps} from '@material-ui/core/InputBase/InputBase'

// ToDo do usunięcia po wrzuceniu libki
export const combineClasses = (...classes: Array<(string | false | undefined)>) => classes.filter((cls) => cls).join(' ');

interface ISearch {
  placeholder?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onReset?: () => void
  classes?: {
    root?: string
    searchInput?: string
    endAdornment?: string
  }
  loader?: InputBaseProps['endAdornment']
  initialValue?: string
}

export type SearchProps = ISearch

// ToDo: jest przygotowany komponent w bibliotece ale paczki sa za stare i to powoduje konflikty, które
//  uniemożliwiają uruchomienie apki. Do podmiany po aktualizacji paczek, głównie react + react-scripts
//  i paczki odpowiadające za odpalenie projektu
const Search: React.FC<ISearch> = ({
  placeholder,
  onChange,
  onReset,
  classes,
  loader,
  initialValue = ''
}) => {
  const [value, setValue] = useState(initialValue)

  const handleChange: ISearch['onChange'] = (event) => {
    setValue(event.target.value)
    onChange?.(event)
  }

  const handleReset: ISearch['onReset'] = () => {
    setValue('')
    onReset?.()
  }

  return (
    <div className={combineClasses('root', classes?.root)}>
      <InputBase
        id="search"
        onChange={handleChange}
        value={value}
        className={combineClasses('search-input', classes?.searchInput)}
        placeholder={placeholder}
        inputProps={{
          'aria-label': 'search',
          'autoComplete': 'off',
        }}
        startAdornment={
          <label htmlFor="search"><img src={SearchIcon}/></label>
        }
        endAdornment={
          <div className={combineClasses('end-adornment', classes?.endAdornment)}>
            {loader}
            {value && (
              <IconButton onClick={handleReset} disableRipple>
                <img src={ClearIcon}/>
              </IconButton>
            )}
          </div>
        }
      />
    </div>
  );
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/Layout/Search/Search.Component.tsx